import { render } from "./ToolbarSpacer.vue?vue&type=template&id=c152542c&scoped=true"
import script from "./ToolbarSpacer.vue?vue&type=script&lang=js"
export * from "./ToolbarSpacer.vue?vue&type=script&lang=js"

import "./ToolbarSpacer.vue?vue&type=style&index=0&id=c152542c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c152542c"

export default script